import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../achievements/index.scss';
import Banner from '../about-me/component/banner/banner';
import Filter from './component/filter/filter';
import PageNation from './component/pagenation/pagenation';
import { actionCreators } from './store';

class DemandHall extends Component {

  componentDidMount() {
    this.props.fetchPageData();
    const headerLi = document.querySelectorAll('.pc-header__item')
    if(headerLi.length>0){
      headerLi.forEach(item=>{
        item.className = "pc-header__item"
      })
    }
  }

  render() {

    const { head } = this.props;

    return (
      <div className="ach-content demand-hall">
        <Banner title={ head.get('name') } bannerSrc={ head.get('logo') } desc={ head.get('des') } en={ head.get('en') }></Banner>
        <Filter></Filter>
        <PageNation></PageNation>
      </div>
    )
  }
}

const mapState = (state) => ({
  head: state.getIn(['hall', 'head'])
});

const mapDispatch = (dispatch) => ({
  fetchPageData() {
    dispatch(actionCreators.fetchHallData())
  }
});

export default connect(mapState, mapDispatch)(DemandHall);
